<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="isEditMode ? 'Insurance Policy' : 'Add Policy'"
      [linkIcon]="isEditMode ? 'trash' : ''"
      (linkAction)="deleteInsurance()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Property & Provider'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-select
              [label]="'Property'"
              [form]="form.controls.address_id"
              formControlName="address_id"
              [items]="addressItems"
              [icon]="'assets/svg/home-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please select a property.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              [label]="'Provider Name'"
              formControlName="provider_name"
              [form]="form.controls.provider_name"
              [icon]="'assets/svg/business-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a provider name.'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              [label]="'Policy Number'"
              formControlName="policy_number"
              [form]="form.controls.policy_number"
              [icon]="'assets/svg/document-text-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a policy number.'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Coverage Type'"
              [form]="form.controls.coverage_type"
              formControlName="coverage_type"
              [items]="coverageTypeItems"
              [icon]="'assets/svg/shield-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please select a coverage type.'" />
          </tidy-row>
        </form>
      </tidy-card>

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Financial Details'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              [label]="'Coverage Amount ($)'"
              formControlName="coverage_amount"
              [form]="form.controls.coverage_amount"
              [icon]="'assets/svg/cash-outline.svg'"
              [inputMode]="'decimal'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              [label]="'Annual Premium ($)'"
              formControlName="annual_premium_amount"
              [form]="form.controls.annual_premium_amount"
              [icon]="'assets/svg/cash-outline.svg'"
              [inputMode]="'decimal'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Deductible ($)'"
              formControlName="deductible_amount"
              [form]="form.controls.deductible_amount"
              [icon]="'assets/svg/cash-outline.svg'"
              [inputMode]="'decimal'" />
          </tidy-row>
        </form>
      </tidy-card>

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Dates & Renewal'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-datepicker
              [label]="'Effective Date'"
              formControlName="effective_date"
              [form]="form.controls.effective_date" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-datepicker
              [label]="'Expiration Date'"
              formControlName="expiration_date"
              [form]="form.controls.expiration_date" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [body]="'Auto Renew'" />
            <tidy-toggle
              [toggled]="autoRenew"
              (toggleChanged)="toggleAutoRenew()" />
          </tidy-row>
        </form>
      </tidy-card>

      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [header]="'Agent Contact'" />
        </tidy-row>
        <form [formGroup]="form">
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              [label]="'Agent Name'"
              formControlName="agent_name"
              [form]="form.controls.agent_name"
              [icon]="'assets/svg/person-circle.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input-international-phone
              formControlName="agent_phone"
              [label]="'Agent Phone'"
              [form]="form.controls.agent_phone"
              [inputMode]="'numeric'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid phone.'"
              [icon]="'assets/svg/phone-portrait.svg'"
              [initialMask]="{ mask: '[00000000000000000000000]' }"
              (countryCodeChange)="onCountryCodeChange($event)" />
          </tidy-row>
        </form>
      </tidy-card>

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }

      <tidy-row [alignLastItemRight]="true">
        @if (isEditMode && isRightSideContent) {
          <tidy-text
            [actionBody]="'Delete Policy'"
            (action)="deleteInsurance()"
            class="delete-automation-link" />
        }
        <tidy-button
          [text]="isEditMode ? 'Save Changes' : 'Add Policy'"
          [action]="boundSave"
          class="primary" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
